import styled from 'styled-components/macro'
import { theme } from 'styled-tools'

const SectionSubTitle = styled.h2`
  font-size: 1em;
  font-weight: ${theme('fontWeights.bold')};
`

export default SectionSubTitle
